import styled from "styled-components";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import Heart from "react-heart";
import { EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import { TextTheme, ButtonTheme, ColorTheme, TallTextTheme, GradientTheme, ShadowTheme, BorderRadiusTheme, SpacingTheme } from "../../components/globaStyledComponents/globalStyledComponentsStyling";
// Styling for view listing page

interface ViewListingPageContainerProps {
    isScrolled?: boolean;
}

export const ViewListingPageContainer = styled.div<ViewListingPageContainerProps>`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    background: white;
    // border-bottom-left-radius: 16px;
    // border-bottom-right-radius: 16px;
    box-shadow: 1.3px 3px 16px 0px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;
    z-index: 3;
    &::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: 768px) {
        width: calc(100% - 16px);
        margin-left: 8px;
        margin-top: ${props => props.isScrolled ? '8px' : '80px'};
        margin-right: 8px;
        border-radius: 16px;
        height: 100vh;
        background: #fff;
        backdrop-filter: blur(32px);
        transition: margin-top 0.2s ease;
    }

    @media (min-width: 1024px) {
        // width: calc(100% - 72px);
        // margin-left: 72px;
    }
`;



export const ViewListingContainer = styled.div`
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 24px;
    
    @media (max-width: 767px) {
        padding: 0;
        background: rgba(255, 255, 255, 0.35);
        backdrop-filter: blur(80px);
        border-top-left-radius: 24px;
        border-top-right-radius: 24px;
        margin-top: -12px;
        position: relative;
        padding: 24px 20px 0;
        z-index: 2;
    }

    @media (min-width: 768px) {
        padding: 0 40px;
    }

    @media (min-width: 1280px) {
        padding: 0 80px;
    }
`;
export const ViewListingTopContainerWrapper = styled.div`
    display: flex;
    width: 100%;
    gap: 40px;
    // margin-top: 32px;
    @media (min-width: 1280px) {
        gap: 96px;
    }
`;
export const ViewListingTopContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    @media (min-width: 768px) {
        width: 100%;
    }

    @media (min-width: 1024px) {
        width: 58%;
        flex: 1;
    }

    @media (min-width: 1280px) {
        max-width: 656px;
        flex: 1;
    }
`;

//ViewListingCarousel
export const CarouselWrapper = styled.div`
    width: 100%;
    padding-bottom: 32px;
    margin-left: -25vw;
    width: calc(100% + 25vw);

    @media (max-width: 767px) {
        margin-left: 0;
        width: 100%;
        padding-bottom: 0;
    }
`;

export const CarouselViewport = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;
`;

export const CarouselContainer = styled.div`
    display: flex;
`;

export const CarouselSlide = styled.div`
    flex-shrink: 0;
    height: 320px;
    margin-right: 8px;
    width: 100%;

    @media (max-width: 767px) {
        margin-right: 0;
        width: 100%;
    }

    @media (min-width: 768px) {
        height: 48vh;
        margin-right: 8px;
        width: auto;
    }

    @media (min-width: 1024px) {
        height: 58vh;
        max-height: 560px;
        max-width: 800px;
    }

    @media (min-width: 1280px) {
        // height: 480px;
    }
`;

export const CarouselPageContainer = styled.div`
    z-index: 1;
    position: relative;
    margin-bottom: -13px;
    @media (min-width: 768px) {
        margin-bottom: auto;
    }
`;

export const CarouselMobileBackButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    position: absolute;
    left: 16px;
    top: 16px;
    z-index: 2;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    border: none;
    cursor: pointer;
    backdrop-filter: blur(8px);

    @media (min-width: 768px) {
        display: none;
    }
`;

export const CarouselMobileShareButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    position: absolute;
    right: 68px;
    top: 16px;
    z-index: 2;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    border: none;
    cursor: pointer;
    backdrop-filter: blur(8px);

    @media (min-width: 768px) {
        display: none;
    }
`;

export const CarouselMobileSaveButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 2;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    border: none;
    cursor: pointer;
    backdrop-filter: blur(8px);

    @media (min-width: 768px) {
        display: none;
    }
`;

export const CarouselImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0 0 8px 8px;
    cursor: pointer;
    transition: filter 0.3s ease;

    &:hover {
        filter: brightness(85%);
    }
`;

export const CarouselLeftButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    position: absolute;
    left: calc(25vw + 32px);
    top: 45%;
    opacity: 0;
    transition: opacity 0.3s ease;
    border: none;
    cursor: pointer;
    backdrop-filter: blur(8px);
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);

    @media (max-width: 767px) {
        display: none;
    }
`;

export const CarouselRightButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    position: absolute;
    right: 32px;
    top: 45%;
    opacity: 0;
    transition: opacity 0.3s ease;
    border: none;
    cursor: pointer;
    backdrop-filter: blur(8px);
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);

    @media (max-width: 767px) {
        display: none;
    }
`;

export const CarouselViewportWithHover = styled(CarouselViewport)`
    &:hover {
        ${CarouselLeftButton}, ${CarouselRightButton} {
            opacity: 1;
        }
    }
`;





// View listing title
export const ViewListingTitleWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    @media (min-width: 768px) {
        justify-content: center;
    }
`;





export const ViewListingSubtitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    width: 100%;
`;

export const ViewListingSubtitle = styled.p`
    padding-right: 44px;
    font-size: ${TextTheme.sans_600_semi.fontSize};
    line-height: ${TextTheme.sans_600_semi.lineHeight};
    font-family: ${TextTheme.sans_600_semi.fontFamily};
    margin: 0;

    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_700_semi.fontSize};
        line-height: ${TextTheme.sans_700_semi.lineHeight};
    }
`;

export const ViewListingTitleSubtitle = styled.h2`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    padding: 0;
    margin: 0;
    margin-top: 16px;

    span {
        text-transform: capitalize;
        font-family: ${TextTheme.sans_400_semi.fontFamily};
    }
`;

export const ViewListingTitleAmenities = styled.div`
    font-size: ${TextTheme.sans_400.fontSize};
    line-height: ${TextTheme.sans_400.lineHeight};
    font-family: ${TextTheme.sans_400.fontFamily};
    color: ${ColorTheme.Grey.color};
    margin-top: 4px;

    @media (max-width: 768px) {
        font-size: ${TextTheme.sans_300_semi.fontSize};
        line-height: ${TextTheme.sans_300_semi.lineHeight};
    }
`;

export const ViewListingTitleReview = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: ${SpacingTheme.spacing_200.margin};
`;

export const ViewListingTitleReviewStar = styled.div`
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ViewListingTitleReviewText = styled.p`
    font-size: ${TextTheme.sans_350.fontSize};
    line-height: ${TextTheme.sans_350.lineHeight};
    font-family: ${TextTheme.sans_350.fontFamily};
    color: ${ColorTheme.Black.color};

    strong {
        margin-left: 4px;
    }
`;

export const ViewListingStarRatingWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 8px;
    margin-bottom: 8px;
`;

export const ViewListingStarRatingDot = styled.div`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${ColorTheme.Black.color};
`;

export const ViewListingReviewCount = styled.button`
    font-family: ${TextTheme.sans_300_semi.fontFamily};
    font-size: ${TextTheme.sans_300_semi.fontSize};
    line-height: ${TextTheme.sans_300_semi.lineHeight};
    position: relative;
    text-decoration: underline;
    color: ${ColorTheme.Black.color};
    margin-left: 4px;
`;



export const ViewListingDesktopMenuWrapper = styled.div`
    display: none;

    @media (min-width: 1024px) {
        width: 33%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    @media (min-width: 1280px) {
        width: 376px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
    }
`;

export const ViewListingDesktopMenu = styled.div`
    width: 100%;
    box-shadow: 2px 6px 24px -4px rgba(0, 0, 0, 0.25);
    border-radius: ${BorderRadiusTheme.radius_24.borderRadius};
    margin: 0 0 48px;
    padding: ${SpacingTheme.spacing_400.padding} 24px 0;
    position: sticky;
    top: 80px;

    @media (max-width: 1023px) {
        display: none;
    }
    @media (min-width: 1280px) {
        margin-right: 0;
    }
`;

export const ViewListingDesktopMenuPrice = styled.p`
    font-size: ${TextTheme.sans_400.fontSize};
    font-family: ${TextTheme.sans_400.fontFamily};
    line-height: ${TextTheme.sans_300.lineHeight};
    margin: 0;
    span {
        font-size: ${TextTheme.sans_700_semi.fontSize};
        font-family: ${TextTheme.sans_700_semi.fontFamily};
        line-height: ${TextTheme.sans_700_semi.lineHeight};
    }
`;

export const ViewListingDesktopMenuDatesWrapper = styled.div`
    width: 100%;
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
    border: 1px solid ${ColorTheme.Grey1.color};
    display: grid;
    height: 120px;
    margin-top: ${SpacingTheme.spacing_400.margin};
`;

export const ViewListingDesktopMenuDatesItem = styled.button`
    width: 100%;
    height: 100%;
    background: none;
    padding: 0;
    border: none;
    text-align: left;
    cursor: pointer;
    display: flex;
    padding: ${SpacingTheme.spacing_250.padding};
    flex-direction: column;
`;

export const ViewListingDesktopMenuDatesItemTitle = styled.p`
    font-size: ${TextTheme.sans_200_semi.fontSize};
    font-family: ${TextTheme.sans_200_semi.fontFamily};

    line-height: ${TextTheme.sans_200_semi.lineHeight};
    margin: 0 0 2px;
`;

export const ViewListingDesktopMenuDatesItemSubtitle = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};

    line-height: ${TextTheme.sans_300.lineHeight};
    margin: 0;
`;

export const ViewListingDesktopMenuDatesSelectSubtitle = styled.p`
    margin: 0 auto;
    margin-top: ${SpacingTheme.spacing_300.margin};
    margin-bottom: ${SpacingTheme.spacing_400.margin};
    text-align: center;
    max-width: 250px;
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};
    color: #737373;
`;

interface ViewListingDesktopMenuDatesSubtotalProps {
    showBreakdown?: boolean;
}
export const ViewListingDesktopMenuDatesSubtotal = styled.p<ViewListingDesktopMenuDatesSubtotalProps>`
    font-size: ${TextTheme.sans_400.fontSize};
    font-family: ${TextTheme.sans_400.fontFamily};
    line-height: ${TextTheme.sans_400.lineHeight};

    margin: 0;
    cursor: ${(props) => (props.showBreakdown ? "pointer" : "default")};
    text-decoration: ${(props) => (props.showBreakdown ? "underline" : "none")};
`;

export const ViewListingDesktopMenuDatesTotal = styled.p`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    line-height: ${TextTheme.sans_400_semi.lineHeight};

    margin: 0;
`;

export const ViewListingDesktopMenuDatesDivider = styled.div`
    width: 100%;
    height: 1px;
    background: ${ColorTheme.Grey2.color};
    margin: ${SpacingTheme.spacing_400.margin} 0;
`;

export const ViewListingTitleTitle = styled.h1`
    font-size: ${TextTheme.sans_900_semi.fontSize};
    line-height: ${TextTheme.sans_900_semi.lineHeight};
    font-family: ${TextTheme.sans_900_semi.fontFamily};
    padding: 0;
    overflow-wrap: break-word;

    @media (min-width: 768px) {
        font-size: 28.5px;
        line-height: 32px;
    }
`;


// ViewListing No Service Fee
export const ViewListingNoServiceFeeWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-top: 1px solid ${ColorTheme.Grey2.color};
    border-bottom: 1px solid ${ColorTheme.Grey2.color};
    padding: 20px 12px;
    background: #f4f3ed;
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
    border: 1px solid ${ColorTheme.Grey3.color};
`;
export const ViewListingHighlightIconWrapper = styled.div`
    width: 48px !important;
    height: 48px !important;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
`;
export const ViewListingNoServiceFeeIcon = styled.img`
    width: 32px;
    height: 32px;
`;
export const ViewListingHighlightTextWrapper = styled.div`
    width: 265px;
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    gap: ${SpacingTheme.spacing_100.gap};

    @media (min-width: 768px) {
        width: fit-content;
    }
`;
export const ViewListingNoServiceFeeTitle = styled.p`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
`;
export const ViewListingHighlightSubtitle = styled.p`
    font-size: ${TallTextTheme.sans_text_200.fontSize};
    line-height: ${TallTextTheme.sans_text_200.lineHeight};
    font-familyt: ${TallTextTheme.sans_text_200.fontFamily};
    color: ${ColorTheme.Grey.color};
`;



// View listing first review section
export const ViewListingReviewWrapper = styled.div`
    width: 100%;
    padding: ${SpacingTheme.spacing_400.padding} 0;
    margin: 0;
    border-bottom: 1px solid ${ColorTheme.Grey2.color};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    overflow: hidden;

    @media (min-width: 768px) {
        padding: ${SpacingTheme.spacing_500.padding} 0;
    }
`;

export const ViewListingSectionWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: ${SpacingTheme.spacing_400.margin};
    &:last-child {
        margin-bottom: 0;
    }
`;



interface ViewListingReviewTitleProps {
    reviews: object[];
}
export const ViewListingReviewTitle = styled.p<ViewListingReviewTitleProps>`
    font-size: ${(props) => (props.reviews.length !== 0 ? TextTheme.sans_800_semi.fontSize : TextTheme.sans_400_semi.fontSize)};
    line-height: ${(props) => (props.reviews.length !== 0 ? TextTheme.sans_800_semi.lineHeight : TextTheme.sans_400_semi.lineHeight)};
    font-weight: ${(props) => (props.reviews.length !== 0 ? TextTheme.sans_800_semi.fontFamily : TextTheme.sans_400_semi.fontFamily)};
`;



export const ViewListingReviewContentSubtitle = styled.p`
    font-size: ${TallTextTheme.sans_text_200.fontSize};
    line-height: ${TallTextTheme.sans_text_200.lineHeight};
    font-familyt: ${TallTextTheme.sans_text_200.fontFamily};
    color: ${ColorTheme.Grey.color};
    max-width: 480px;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

// View listing description
export const ViewListingDescriptionWrapper = styled.div`
    width: 100%;
    margin: 0;
    padding: ${SpacingTheme.spacing_500.padding} 0;
    border-bottom: 1px solid ${ColorTheme.Grey2.color};
`;

export const ViewListingDescriptionText = styled.p`
    font-size: ${TallTextTheme.sans_text_300.fontSize};
    line-height: ${TallTextTheme.sans_text_300.lineHeight};
    margin: 0;
    font-familyt: ${TallTextTheme.sans_text_300.fontFamily};

    max-width: 100%;
    word-wrap: break-word;
`;

// Available room styling
interface ViewLisitingAvailableRoomWrapperProps {
    hasAmenities?: boolean;
}

export const ViewLisitingAvailableRoomWrapper = styled.div<ViewLisitingAvailableRoomWrapperProps>`
    width: 100%;
    padding: ${SpacingTheme.spacing_500.padding} 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    border-bottom: ${props => props.hasAmenities ? `1px solid ${ColorTheme.Grey2.color}` : 'none'};
    @media (min-width: 768px) {
        padding: ${SpacingTheme.spacing_600.padding} 0;
    }
`;

export const ViewLisitingAvailableRoomTitle = styled.h4`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    font-family: ${TextTheme.sans_700_semi.fontFamily};

    line-height: ${TextTheme.sans_700_semi.lineHeight};
    margin: 0;
    padding: 0;

    @media (min-width: 768px) {
        position: absolute;
        padding: 0;
    }
`;

export const ViewLisitingAvailableRooms = styled(Swiper)`
    width: calc(100% + 48px);
    display: flex;
    padding-top: 24px;
    position: relative;
    padding-left: 24px;
    margin-left: -24px;

    &:last-child {
        padding-right: 24px;
    }

    ::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: 768px) {
        width: calc(100% + 32px);
        padding-left: 16px;
        padding-right: 16px;
        margin-left: -16px;
        height: 100%;
        padding-top: 50px;
        &:last-child {
            padding-right: 24px;
        }
    }

    @media (min-width: 1024px) {
        &:last-child {
            padding-right: 16px;
        }
    }
    .swiper-button-next,
    .swiper-button-prev {
        top: 48%;
        transform: translateY(-50%);
        height: 36px;
        width: 36px;
        right: 0;
        margin-right: 16px;
        border-radius: 50%;
        background: ${ColorTheme.White.color};
        color: ${ColorTheme.Black.color};
        box-shadow: ${ShadowTheme.shadow_100.boxShadow};
        display: none;
    }
    .swiper-button-prev {
        left: 0;
        margin-right: 0;
        margin-left: 16px;
    }
    .swiper-button-next:after,
    .swiper-button-prev:after {
        font-size: 14px !important;
    }
    .swiper-button-disabled {
        display: none;
    }
`;

interface ViewLisitingSwiperButtonProps {
    selected: boolean;
}
export const ViewLisitingSwiperButton = styled.button<ViewLisitingSwiperButtonProps>`
    height: 32px;
    width: 32px;
    border-radius: 50%;
    background: ${ColorTheme.White.color};
    border-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 1px solid;
    border-color: ${(props) => (props.selected ? `${ColorTheme.Grey2.color}` : `${ColorTheme.Grey1.color}`)};
`;

export const ViewLisitingSwiperButtonWrapper = styled.div`
    min-width: 80px;
    display: flex;
    justify-content: space-between;
    position: relative;
    top: -50px;
    right: 78px;

    @media (max-width: 767px) {
        display: none;
    }

    @media (min-width: 768px) {
        top: -50px;
        right: 0;
    }

    @media (min-width: 1024px) {
        right: 78px;
    }
`;

export const SwiperSlideWrapper = styled(SwiperSlide)`
    width: 200px;

    @media (min-width: 768px) {
        width: 220px;
    }
`;

export const ViewLisitingAvailableRoom = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
    overflow: hidden;
    box-shadow: ${ShadowTheme.shadow_100.boxShadow};
    // border: 1px solid ${ColorTheme.Grey2.color};
    aspect-ratio: 3/2;
`;

export const ViewLisitingAvailableRoomIcon = styled.img`
    width: 24px;
    height: 24px;
`;

export const ViewLisitingAvailableRoomImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
`;

export const ViewLisitingAvailableRoomText = styled.p`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    font-family: ${TextTheme.sans_400_semi.fontFamily};

    margin: 0;
    margin-top: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const ViewLisitingAvailableRoomSubtext = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};
    color: ${ColorTheme.Grey.color};
    margin: 0;
    margin-top: 2px;
`;

export const ViewLisitingAvailableRoomSubtextListItem = styled.li`
    margin: 0;
    padding: 0;
    list-style-type: none;
`;

//
export const ViewListingAmenitiesListWrapper = styled.div`
    width: 100%;
    padding: ${SpacingTheme.spacing_500.padding} 0;
    margin: 0;

    @media (min-width: 768px) {
        padding: ${SpacingTheme.spacing_600.padding} 0;
        width: 100%;
    }
    @media (min-width: 1280px) {
        margin: 0;
    }
`;

export const ViewListingAmenitiesListTitle = styled.p`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
    font-family: ${TextTheme.sans_700_semi.fontFamily};

    margin: 0;
    margin-bottom: 24px;
`;

export const ViewListingAmenitiesListContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    gap: ${SpacingTheme.spacing_300.gap} 0;

    @media (min-width: 768px) {
        grid-template-columns: 50% 50%;
    }
`;

export const ViewListingAmenitiesListItem = styled.div`
    display: flex;
    align-items: center;
    gap: ${SpacingTheme.spacing_300.gap};
`;

export const ViewListingAmenitiesListItemIcon = styled.img`
    width: 24px;
    height: 24px;
    padding: 0;
    margin: 0;
`;

export const ViewListingAmenitiesListItemText = styled.p`
    font-size: ${TextTheme.sans_400.fontSize};
    line-height: ${TextTheme.sans_400.lineHeight};
    font-family: ${TextTheme.sans_400.fontFamily};

    margin: 0;
    padding: 0;
`;

export const ViewListingAmenitiesMoreButton = styled.button`
    border: none;
    background: none;
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    margin: 0;
    margin-top: 32px;
    cursor: pointer;
    height: 48px;
    width: 100%;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    background: none;
    border: 1px solid ${ColorTheme.Grey1.color};
    cursor: pointer;

    @media (min-width: 768px) {
        width: fit-content;
        padding: 0 24px;
        margin-top: 48px;
    }
`;

export const ViewListingReadMoreButton = styled.button`
    display: inline;
    border: none;
    background: none;
    text-decoration: underline;
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};

    margin: 0;
    padding: 0;
    cursor: pointer;
    background: none;
`;
//
export const ViewListingAboutLocationWrapper = styled.div`
    width: 100%;
    padding: ${SpacingTheme.spacing_500.padding} 0;
    border-top: 1px solid ${ColorTheme.Grey2.color};
    @media (min-width: 768px) {
        padding: ${SpacingTheme.spacing_600.padding} 0;
    }
`;

export const ViewListingReviewsWrapper = styled.div`
    width: 100%;
    border-top: 1px solid ${ColorTheme.Grey2.color};
    margin-bottom: 32px;
    padding-top: 32px;

    @media (min-width: 768px) {
        margin-bottom: 48px;
        padding-top: 48px;
    }
`;

export const ViewListingReviewsItemWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    overflow-x: auto;
    padding-bottom: 8px;

    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const ViewListingReviewsHeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 32px;
    gap: 24px;

    @media (min-width: 768px) {
        gap: 24px;
    }
`;

export const ViewListingReviewsHeaderRating = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
`;

export const ViewListingReviewsHeaderRatingStar = styled.div`
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ViewListingReviewsHeaderDivider = styled.div`
    width: 1px;
    height: 24px;
    margin: 0 24px;
    background-color: ${ColorTheme.Grey2.color};
`;

export const ViewListingReviewsHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${SpacingTheme.spacing_200.gap};
    justify-content: flex-end;
`;

export const ViewListingReviewsHeaderRatingTitle = styled.p`
    font-size: ${TextTheme.sans_900_semi.fontSize};
    font-family: ${TextTheme.sans_900_semi.fontFamily};
    line-height: ${TextTheme.sans_900_semi.lineHeight};
    font-style: normal;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    gap: 4px;

    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_1000_semi.fontSize};
        font-family: ${TextTheme.sans_1000_semi.fontFamily};
        line-height: ${TextTheme.sans_1000_semi.lineHeight};
    }
`;

export const ViewListingReviewsHeaderRatingOutOf = styled.span`
    font-size: ${TextTheme.sans_300_semi.fontSize};
    line-height: ${TextTheme.sans_300_semi.lineHeight};
    font-family: ${TextTheme.sans_300_semi.fontFamily};
    color: ${ColorTheme.Black.color};
    display: block;
`;

interface ViewListingReviewsCommentSwiperWrapperProps {
    isShow: boolean;
}
export const ViewListingReviewsCommentSwiperWrapper = styled.div<ViewListingReviewsCommentSwiperWrapperProps>`
    width: 100%;
    height: fit-content;
    position: relative;
    display: ${(props) => (props.isShow ? `block` : `hidden`)};
`;

export const ViewListingNoReviewsCommentWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
`;

export const ViewListingNoReviewsCommentTitle = styled.p`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
    color: ${ColorTheme.Grey1.color};
    margin-bottom: 12px;
    display: none;
`;

export const ViewListingNoReviewsCommentSubtitle = styled.div`
    font-size: ${TextTheme.sans_500.fontSize};
    font-family: ${TextTheme.sans_500.fontFamily};
    line-height: ${TextTheme.sans_500.lineHeight};
    color: ${ColorTheme.Grey1.color};
    margin-bottom: 32px;
`;

export const ViewListingReviewsSeeAllReviewBtn = styled.button`
    color: ${ColorTheme.White.color};
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: 32px;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    border: 1px solid ${ColorTheme.Black.color};
    height: 40px;
    background-color: ${ColorTheme.Black.color};
    font-size: ${TextTheme.sans_300_semi.fontSize};
    font-family: ${TextTheme.sans_300_semi.fontFamily};
    line-height: ${TextTheme.sans_300_semi.lineHeight};
    cursor: pointer;

    @media (min-width: 768px) {
        width: fit-content;
        border: 1px solid ${ColorTheme.Black.color};
        border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
        padding: 0 32px;
        height: 48px;
        margin-top: 48px;

        font-size: ${TextTheme.sans_400_semi.fontSize};
        font-family: ${TextTheme.sans_400_semi.fontFamily};
        line-height: ${TextTheme.sans_400_semi.lineHeight};
    }
`;

export const ViewListingReviewsCommentSwiper = styled.div`
    width: 100%;
    height: 100%;
`;

export const ViewListingAboutLocationTitle = styled.p`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
    font-family: ${TextTheme.sans_700_semi.fontFamily};

    margin: 0;
    padding: 0;
    margin-bottom: 24px;
`;

export const ViewListingAboutLocationSubtitle = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};

    margin: 0;
    padding: 0;
    margin-top: 16px;

    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_400.fontSize};
        line-height: ${TextTheme.sans_400.lineHeight};
    }

    display: none;
`;

export const ViewListingLocationVerification = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 24px;
    color: ${ColorTheme.Grey3.color};
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};

    img {
        width: 16px;
        height: 16px;
        object-fit: contain;
    }

    span {
        color: ${ColorTheme.Grey.color};
    }
`;

export const ViewListingLocationVerificationIcon = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${ColorTheme.Grey5.color};
    border-radius: 50%;
`;

export const ViewListingMapWrapper = styled.div`
    width: 100%;
    height: 400px;
    border-radius: ${BorderRadiusTheme.radius_24.borderRadius} !important;
    position: relative;
    overflow: hidden;

    @media (min-width: 768px) {
        height: 480px;
    }
`;

// View Listing Expandable section
export const ViewListingExpandableSectionContainer = styled.div`
    width: 100%;
    padding: ${SpacingTheme.spacing_500.padding} 0;
    border-top: 1px solid ${ColorTheme.Grey2.color};

    @media (min-width: 768px) {
        border-top: none;
        margin: 0;
        width: 33%;
        padding: 24px 48px 0 0;
    }
`;

export const ViewListingExpandableSectionContainerCancel = styled.div`
    width: 100%;
    padding: ${SpacingTheme.spacing_500.padding} 0;
    border-top: 1px solid ${ColorTheme.Grey2.color};

    @media (min-width: 768px) {
        width: 33%;
        border: none;
        padding: 24px 0 0;
    }
`;
export const ViewListingExpandableSectionWrapper = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 100%;
`;

export const ViewListingExpandableSectionTitle = styled.p`
    grid-column: 1/2;
    grid-row: 1/2;
    margin: 0;
    padding: 0;
    font-size: ${TextTheme.sans_500_semi.fontSize};
    font-family: ${TextTheme.sans_500_semi.fontFamily};

    line-height: ${TextTheme.sans_500_semi.lineHeight};
    margin-bottom: 8px;

    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_400_semi.fontSize};
        line-height: ${TextTheme.sans_400_semi.lineHeight};
    }
`;

export const ViewListingExpandableSectionSubtitle = styled.p`
    grid-column: 1/2;
    grid-row: 1/2;
    margin: 0;
    padding: 0;
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};

    line-height: ${TextTheme.sans_300.lineHeight};
    margin-top: 40px;
`;

// SHare button styling




export const ViewListingSaveButton = styled(Heart)`
    height: 16px;
    width: 16px;
    user-select: none;
`;

export const ViewListingExapndableDesktopWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    @media (min-width: 768px) {
        flex-direction: row;
        padding-bottom: 80px;
    }
`;

export const ViewListingThingsToKnow = styled.p`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
`;

export const ViewListingThingsToKnowWrapper = styled.div`
    border-top: 1px solid ${ColorTheme.Grey2.color};
    padding-top: 40px;
    padding-bottom: 40px;

    @media (min-width: 768px) {
        padding-bottom: 0;
    }
`;

export const ViewListingOwnerSectionProfileWrapper = styled.div`
    display: flex;
    gap: 16px;
    margin-bottom: 32px;
`;
export const ViewListingOwnerTextAvatar = styled.div`
    height: 64px;
    width: 64px;
    border-radius: 50%;
    border: 1px solid ${ColorTheme.Grey2.color};
    background-color: ${ColorTheme.White.color};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${TextTheme.sans_700_semi.fontSize};
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
    color: ${ColorTheme.Black.color};
`;

export const ViewListingOwnerSectionWrapper = styled.div`
    width: 100%;
    border: none;
    background: none;
    text-align: left;
    border-top: 1px solid ${ColorTheme.Grey2.color};
    display: flex;
    padding: 32px 0 32px;
    flex-direction: column;
    gap: 32px;

    @media (min-width: 1024px) {
        flex-direction: row;
        padding: 48px 0 48px;
        justify-content: space-between;
    }
`;

export const ViewListingOwnerSectionLeft = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    max-width: 100%;

    @media (min-width: 1024px) {
        max-width: 33.33%;
    }
`;

export const ViewListingOwnerSectionRight = styled.div`
    flex: 2;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const ViewListingFAQColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const ViewListingFAQColumnHotel = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px 16px;
    
    @media (min-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

export const ViewListingFAQTitle = styled.h3`
    font-size: ${TextTheme.sans_500.fontSize};
    font-family: ${TextTheme.sans_500.fontFamily};
    line-height: ${TextTheme.sans_500.lineHeight};
    color: ${ColorTheme.Black.color};
    margin: 0;
`;

export const ViewListingFAQItem = styled.div`
    display: flex;
    flex-direction: column;
    background: ${ColorTheme.Grey4.color};
    border-radius: 12px;
    overflow: hidden;
`;

export const ViewListingFAQHeader = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px;
    border: none;
    background: none;
    cursor: pointer;
`;

export const ViewListingFAQContent = styled.div<{ isExpanded: boolean }>`
    padding: ${props => props.isExpanded ? '0 16px 16px' : '0 16px'};
    max-height: ${props => props.isExpanded ? '500px' : '0'};
    opacity: ${props => props.isExpanded ? '1' : '0'};
    overflow: hidden;
    transition: all 0.3s ease-in-out;
`;

export const ViewListingFAQIcon = styled.img<{ isExpanded: boolean }>`
    width: 8px;
    height: 12px;
    transform: rotate(${props => props.isExpanded ? "90deg" : "-90deg"});
    transition: 0.1s;
    object-fit: cover;
    margin-left: 16px;
`;

export const ViewListingFAQQuestion = styled.h4`
    font-size: ${TextTheme.sans_400.fontSize};
    font-family: ${TextTheme.sans_400.fontFamily};
    line-height: ${TextTheme.sans_400.lineHeight};
    color: ${ColorTheme.Black.color};
    margin: 0;
`;

export const ViewListingFAQAnswer = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${TextTheme.sans_300.lineHeight};
    color: ${ColorTheme.Grey.color};
    margin: 0;
`;





export const ViewListingOwnerSectionImage = styled.img`
    height: 64px;
    width: 64px;
    object-fit: cover;
    border-radius: 50%;
`;

export const ViewListingOwnerSectionTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: auto 0;
`;

export const ViewListingOwnerSectionTitle = styled.h3`
    font-size: ${TextTheme.sans_700.fontSize};
    line-height: ${TextTheme.sans_700.lineHeight};
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    margin: 0 0 4px 0;
    padding: 0;
`;

export const ViewListingOwnerSectionTextTitle = styled.p`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
    margin: 0;
`;

export const ViewListingOwnerSectionText = styled.p`
    font-size: ${TallTextTheme.sans_text_300.fontSize};
    font-family: ${TallTextTheme.sans_text_300.fontFamily};
    line-height: ${TallTextTheme.sans_text_300.lineHeight};
    margin: 0;
    span {
        font-family: ${TextTheme.sans_300_semi.fontFamily};
    }
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;

    @media (min-width: 768px) {
        max-width: 100%;
        word-wrap: break-word;
    }
`;

export const ViewListingOwnerSectionDetailText = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${TextTheme.sans_300.lineHeight};
    margin: 0;
    color: ${ColorTheme.Black.color};
`;

export const ViewListingOwnerSectionSubtitle = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${TextTheme.sans_300.lineHeight};
    color: ${ColorTheme.Grey.color};
    margin: 0;
`;

export const ViewListingOwnerSectionQuestionButton = styled.button`
    width: 100%;
    border: none;
    height: 48px;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    border: 1px solid ${ColorTheme.Grey1.color};
    margin: 0;
    padding: 0;
    cursor: pointer;
    background: none;

    @media (min-width: 768px) {
        padding: 0 24px;
        width: fit-content;
        background: none;
    }
`;



export const ViewListingFooterWrapper = styled.div`
    position: fixed;
    left: 0;
    z-index: 100;
    bottom: 16px;
    display: grid;
    grid-template-columns: auto 124px;
    grid-template-rows: 100%;
    padding: 12px 12px 12px 20px;
    background: rgba(255, 255, 255, 0.35);
    backdrop-filter: blur(16px);
    width: calc(100% - 24px);
    border: 1px solid ${ColorTheme.Grey3.color};
    align-items: center;
    box-shadow: 2px 4px 24px 0px rgba(0, 0, 0, 0.15);
    border-radius: 100px;
    margin: 0 12px;

    @media (min-width: 768px) {
        width: calc(100% - 48px);
        margin: 0 24px;
    }

    @media (min-width: 1024px) {
        display: none;
    }
`;

interface ViewListingFooterButtonProps {
    inactive?: boolean;
}
export const ViewListingFooterButton = styled.button<ViewListingFooterButtonProps>`
    width: 100%;
    height: 48px;
    grid-row: 1/2;
    grid-column: 2/3;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    color: ${ColorTheme.White.color};
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    cursor: pointer;
    background: ${(props) => (props.inactive ? ColorTheme.Grey1.color : ColorTheme.Black.color)};
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (min-width: 1024px) {
        margin-top: 16px;
    }

    /* &:hover {
        transition: 0.2s ease-in-out;
        background: ${(props) => (props.inactive ? ColorTheme.Grey5.color : ColorTheme.Black.color)};
    } */
`;

export const ViewListingFooterTextWrapper = styled.div`
    grid-row: 1/2;
    grid-column: 1/2;
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-items: center;
`;

export const ViewListingFooterTitleText = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${TextTheme.sans_300.lineHeight};
    color: ${ColorTheme.Grey.color};
    margin: 0;

    span {
        font-family: ${TextTheme.sans_400_semi.fontFamily};
        font-size: ${TextTheme.sans_400_semi.fontSize};
        line-height: ${TextTheme.sans_400_semi.lineHeight};
        color: ${ColorTheme.Black.color};
    }
`;

interface ViewListingFooterSubtitleTextProps {
    underlineActive: boolean;
}
export const ViewListingFooterSubtitleText = styled.p<ViewListingFooterSubtitleTextProps>`
    font-size: ${TextTheme.sans_300.fontSize};
    margin: 0;
    font-family: ${(props) => (props.underlineActive ? TextTheme.sans_300_semi.fontFamily : TextTheme.sans_300.fontFamily)};
    color: ${(props) => (props.underlineActive ? ColorTheme.Black.color : ColorTheme.Grey.color)};
    margin-top: 4px;

    line-height: ${TextTheme.sans_300.lineHeight};
    text-decoration: ${(props) => (props.underlineActive ? "underline" : "none")};
`;

export const ViewListingReservationDatepickerLabelWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 12px;
    position: relative;
`;

export const ViewListingReservationDivider = styled.div`
    width: 100%;
    height: 1px;
    background: ${ColorTheme.Grey2.color};
    margin: ${SpacingTheme.spacing_500.margin} 0;

    @media (min-width: 768px) {
        margin: ${SpacingTheme.spacing_600.margin} 0;
    }
`;

export const ShareListingPopupWrapper = styled.div`
    width: 100%;
    border-radius: 12px 12px 0 0;
    min-height: 90vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 24px;

    @media (min-width: 768px) {
        border-radius: 12px;
        min-height: unset;
    }
`;

export const ShareListingPopupTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    // justify-content: center;
    border-bottom: 1px solid ${ColorTheme.Grey2.color};
    width: 100%;
    height: 64px;
`;

export const ShareListingPopupTitle = styled.p`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    margin: 0 auto;
    padding-right: 16px;
    justify-self: center;
    line-height: ${TextTheme.sans_400_semi.lineHeight};
`;

export const ShareListingPopupHeaderWrapper = styled.div`
    display: grid;
    width: 100%;
    overflow: hidden;
    grid-template-columns: 132px 1fr;
    grid-template-rows: 1fr;
    min-height: 132px;
    padding: ${SpacingTheme.spacing_300.padding} 0;
    border-bottom: 1px solid ${ColorTheme.Grey2.color};
`;

export const ShareListingPopupHeaderImage = styled.img`
    grid-row: 1/2;
    grid-column: 1/2;
    object-fit: cover;
    border-radius: 5px;
    width: 116px;
    height: 100%;
`;

export const ShareListingPopupHeaderPlaceType = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    color: ${ColorTheme.Grey.color};
    line-height: ${TextTheme.sans_300.lineHeight};
    margin: 0;
    margin-bottom: 4px;
`;

export const ShareListingPopupHeaderText = styled.p`
    font-size: ${TextTheme.sans_400.fontSize};
    font-family: ${TextTheme.sans_400.fontFamily};

    line-height: ${TextTheme.sans_400.lineHeight};
    margin: 0;
    margin-bottom: auto;
`;

export const ShareListingPopupHeaderTextPrice = styled.p`
    font-size: ${TextTheme.sans_200.fontSize};
    font-family: ${TextTheme.sans_200.fontFamily};

    line-height: ${TextTheme.sans_200.lineHeight};
    margin: 0;

    span {
        font-size: ${TextTheme.sans_300_semi.fontSize};
        line-height: ${TextTheme.sans_300_semi.lineHeight};
        font-family: ${TextTheme.sans_300_semi.fontFamily};
    }
`;

export const ShareListingDoneButton = styled.button`
    height: 48px;
    width: 100%;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    border: none;
    cursor: pointer;
    background: ${ColorTheme.Red.color};
    color: ${ColorTheme.White.color};
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    line-height: ${ButtonTheme.sans_button_100.lineHeight};
    font-family: ${ButtonTheme.sans_button_100.fontFamily};
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    margin-bottom: 24px;

    @media (min-width: 768px) {
        display: none;
    }
`;

export const ShareListingDivider = styled.div`
    width: 100%;
    height: 1px;
    background: ${ColorTheme.Grey2.color};
    margin: ${SpacingTheme.spacing_400.margin} 0;
    margin-top: auto;

    @media (min-width: 768px) {
        display: none;
    }
`;

export const IndividualEmailShareButton = styled(EmailShareButton)`
    height: 54px;
    width: 100%;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    box-shadow: ${ShadowTheme.shadow_100.boxShadow};
    background: ${ColorTheme.White.color};
    display: flex;
    align-items: center;
    gap: ${SpacingTheme.spacing_300.gap};
    padding-left: 16px !important;
`;

export const IndividualFacebookShareButton = styled(FacebookShareButton)`
    height: 54px;
    width: 100%;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    box-shadow: ${ShadowTheme.shadow_100.boxShadow};
    background: ${ColorTheme.White.color};
    display: flex;
    align-items: center;
    gap: ${SpacingTheme.spacing_300.gap};
    padding-left: 16px !important;
`;

export const IndividualTwitterShareButton = styled(TwitterShareButton)`
    height: 54px;
    width: 100%;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    box-shadow: ${ShadowTheme.shadow_100.boxShadow};
    background: ${ColorTheme.White.color};
    display: flex;
    align-items: center;
    gap: ${SpacingTheme.spacing_300.gap};
    padding-left: 16px !important;
`;

export const IndividualWhatsappShareButton = styled(WhatsappShareButton)`
    height: 54px;
    width: 100%;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    box-shadow: ${ShadowTheme.shadow_100.boxShadow};
    background: ${ColorTheme.White.color};
    display: flex;
    align-items: center;
    gap: ${SpacingTheme.spacing_300.gap};
    padding-left: 16px !important;
`;

export const IndividualShareButton = styled.div`
    height: 54px;
    width: 100%;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    box-shadow: ${ShadowTheme.shadow_100.boxShadow};
    display: flex;
    align-items: center;
    padding-left: 16px;
    gap: ${SpacingTheme.spacing_300.gap};
    cursor: pointer;
`;

export const IndividualShareButtonIcon = styled.img`
    height: 32px;
    width: 32px;
    border-radius: ${BorderRadiusTheme.radius_4.borderRadius};
    object-fit: cover;
`;

export const IndividualShareButtonText = styled.p`
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};

    margin: 0;
`;

export const ViewListingSendMessageRequestWrapper = styled(motion.div)`
    width: 100%;
    border-radius: 12px 12px 0 0;
    display: flex;
    flex-direction: column;

    @media (min-width: 768px) {
        height: fit-content;
        max-width: 568px;
    }
`;

export const ViewListingSendMessageRequestTitle = styled.p`
    font-size: ${TextTheme.sans_800_semi.fontSize};
    line-height: ${TextTheme.sans_800_semi.lineHeight};
    font-family: ${TextTheme.sans_800_semi.fontFamily};
    margin: 0;
    margin-bottom: 8px;
    text-align: left;
    padding-left: 24px;
`;

export const ViewListingSendMessageRequestSubtitle = styled.p`
    font-size: ${TextTheme.sans_400.fontSize};
    line-height: ${TextTheme.sans_400.lineHeight};
    font-family: ${TextTheme.sans_400.fontFamily};
    color: ${ColorTheme.Grey.color};
    margin: 0;
    margin-bottom: 24px;
    text-align: left;
    padding-left: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ViewListingSendMessageRequestTextInput = styled.textarea`
    width: calc(100% - 48px);
    margin: 0 auto;
    height: 160px;
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
    border: 1px solid ${ColorTheme.Grey1.color};
    padding: ${SpacingTheme.spacing_300.padding};
    outline: none;
    resize: none;
    margin-bottom: 24px;
    font-size: ${TextTheme.sans_400.fontSize};
    line-height: ${TextTheme.sans_400.lineHeight};
    font-family: ${TextTheme.sans_400.fontFamily};
    background: none;

    &placeholder {
        color: ${ColorTheme.Grey1.color};
    }
`;

export const ViewListingSendMessageRequestSentTitleWrapper = styled.div`
    width: calc(100% - 48px);
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${SpacingTheme.spacing_350.padding} 0;
`;

export const ViewListingSendMessageRequestSentTitle = styled.p`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    line-height: ${TextTheme.sans_400_semi.lineHeight};

    margin: 0;
`;

export const ViewListingSendMessageRequestSentHeader = styled.div`
    border-top: 1px solid ${ColorTheme.Grey2.color};
    border-bottom: 1px solid ${ColorTheme.Grey2.color};
    width: calc(100% - 48px);
    margin: 0 auto;
    padding: ${SpacingTheme.spacing_300.padding} 0;
    display: flex;
    gap: ${SpacingTheme.spacing_300.gap};
`;

export const ViewListingSendMessageRequestSentImage = styled.img`
    height: 100px;
    aspect-ratio: 4/3;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    object-fit: cover;
`;

export const ViewListingSendMessageRequestSentHeaderTitle = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    color: ${ColorTheme.Grey.color};
    line-height: ${TextTheme.sans_300.lineHeight};
    margin: 0;
    margin-bottom: 4px;
`;

export const ViewListingSendMessageRequestSentHeaderSubtitle = styled.p`
    font-size: ${TextTheme.sans_400.fontSize};
    font-family: ${TextTheme.sans_400.fontFamily};

    line-height: ${TextTheme.sans_400.lineHeight};
    margin: 0;
    margin-bottom: 24px;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const ViewListingSendMessageRequestSentHeaderPrice = styled.p`
    justify-self: flex-end;
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${TextTheme.sans_300.lineHeight};

    span {
        font-size: ${TextTheme.sans_400.fontSize};
        font-family: ${TextTheme.sans_400.fontFamily};
        line-height: ${TextTheme.sans_400.lineHeight};
    }
`;

export const ViewListingSendMessageRequestSentHeaderTotalWrapper = styled.div`
    width: calc(100% - 48px);
    padding: ${SpacingTheme.spacing_400.padding} 0 ${SpacingTheme.spacing_600.padding} 0;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
`;

export const ViewListingSendMessageRequestSentHeaderSubtotal = styled.p`
    margin: 0;
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${TextTheme.sans_300.lineHeight};

    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_400.fontSize};
        line-height: ${TextTheme.sans_400.lineHeight};
    }
`;

export const ViewListingSendMessageRequestSentHeaderTotal = styled.p`
    margin: 0;
    font-size: ${TextTheme.sans_300_semi.fontSize};
    font-family: ${TextTheme.sans_300_semi.fontFamily};
    line-height: ${TextTheme.sans_300_semi.lineHeight};

    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_400_semi.fontSize};
        line-height: ${TextTheme.sans_400_semi.lineHeight};
    }
`;

export const ViewListingHouseRulesIconWrapper = styled.div`
    display: flex;
    gap: ${SpacingTheme.spacing_300.gap};
    align-items: center;
    margin-bottom: 12px;
`;

export const ViewListingHouseRulesIcon = styled.img`
    height: 16px;
    width: 16px;
    object-fit: cover;
`;

export const ViewListingHouseRulesText = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};
    margin: 0;

    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_400.fontSize};
        line-height: ${TextTheme.sans_400.lineHeight};
    }
`;

export const ViewListingHouseRulesIconsWrapper = styled.div`
    margin-top: 16px;
`;

export const ViewListingDamageDepositText = styled.span`
    margin: 0;
    margin-top: 4px;
    font-size: ${TallTextTheme.sans_text_300.fontSize};
    font-familyt: ${TallTextTheme.sans_text_300.fontFamily};
    line-height: ${TallTextTheme.sans_text_300.lineHeight};

    max-width: 300px;

    &strong {
        font-family: ${TextTheme.sans_400_semi.fontFamily};
    }
`;

export const ViewListingDamageDepositLink = styled.a`
    margin: 0;
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    font-family: ${TextTheme.sans_400_semi.fontFamily};

    text-decoration: underline;
    cursor: pointer;
`;

interface ViewListingDesktopHeaderWrapperProps {
    $desktopHeaderActive?: boolean;
}
export const ViewListingDesktopHeaderContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10001;
    display: flex;
    justify-content: center;
    padding-top: 32px;
    pointer-events: none;
    /* background: red;  Remove debug */
`;

export const ViewListingDesktopHeaderWrapper = styled(motion.div)<ViewListingDesktopHeaderWrapperProps>`
    width: 480px;
    height: 72px;
    backdrop-filter: blur(16px);
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    transition: 125ms;
    box-shadow: ${(props) => (props.$desktopHeaderActive ? ShadowTheme.shadow_100.boxShadow : "none")};
    pointer-events: auto;

    @media (max-width: 767px) {
        display: none;
    }
`;

export const ViewListingDesktopHeaderContentWrapper = styled.div`
    display: flex;
    height: 100%;
    padding: 0 12px 0 24px;
    align-items: center;
    max-width: 1184px;
    margin: 0 auto;
    gap: 24px;
`;

export const ViewListingDesktopHeaderPriceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${SpacingTheme.spacing_100.gap};
    /* margin-left: auto; */
    margin-top: 19px;
    margin-bottom: 19px;
`;

export const ViewListingDesktopHeaderPrice = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};
    text-align: left;
    margin: 0;

    strong {
        font-size: ${TextTheme.sans_500_semi.fontSize};
        font-family: ${TextTheme.sans_500_semi.fontFamily};
        line-height: ${TextTheme.sans_500_semi.lineHeight};
    }
`;

export const ViewListingDesktopHeaderMinimum = styled.button`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};
    margin: 0;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    text-align: left;
    color: ${ColorTheme.Grey.color};
`;

export const ViewListingDesktopHeaderReserveButton = styled.button`
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    border: none;
    // background: ${GradientTheme.Red.background};
    background: ${ColorTheme.Black.color};
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    cursor: pointer;
    color: ${ColorTheme.White.color};
    margin-left: auto;
    padding: 0 24px;
    min-width: 112px;

    &:hover {
        transition: 0.2s ease-in-out;
        // background: ${GradientTheme.Red.background};
    }
`;

export const ViewListingReviewsSubtitle = styled.p`
    font-size: 16px;
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${TextTheme.sans_300.lineHeight};
    color: ${ColorTheme.Grey.color};
    margin: 0;
`;



export const ViewListingNoReviewsTitle = styled.p`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    font-style: normal;
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    line-height: ${TextTheme.sans_700_semi.lineHeight};

    margin: 0;
`;



export const ViewListingReviewsAverageAttribute = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const ViewListingReviewsAverageAttributeTitle = styled.p`
    font-size: ${TextTheme.sans_300_semi.fontSize};
    font-family: ${TextTheme.sans_300_semi.fontFamily};

    line-height: ${TextTheme.sans_300_semi.lineHeight};
    margin-top: 0;
    margin-bottom: 8px;
`;

export const ViewListingReviewsAverageAttributeRating = styled.div`
    width: 100%;
    height: 4px;
    background: ${ColorTheme.Grey3.color};
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
`;

interface ViewListingReviewsAverageAttributeRatingInnerProps {
    value: number;
}
export const ViewListingReviewsAverageAttributeRatingInner = styled.div<ViewListingReviewsAverageAttributeRatingInnerProps>`
    height: 4px;
    width: ${(props) => `${props.value * 2 * 10}%`};
    background: ${ColorTheme.Black.color};
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
`;

export const ViewListingReviewsReviewWrapper = styled.div`
    width: 357px;
    height: 260px;
    flex-shrink: 0;
    padding: 20px 20px 16px;
    border-radius: 16px;
    border: 1px solid #e1e1e1;
    background-color: #fff;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
`;

export const ViewListingReviewsExternalPopup = styled.div`
    width: 100%;
    z-index: 1;
    flex-direction: column;
    height: 80px;
    position: absolute;
    top: 64px;
    left: 0;
    border-radius: ${BorderRadiusTheme.radius_16.borderRadius};
    align-items: center;
    padding: ${SpacingTheme.spacing_300.padding};
    font-size: ${TallTextTheme.sans_text_300.fontSize};
    line-height: ${TallTextTheme.sans_text_300.lineHeight};

    box-shadow: ${ShadowTheme.shadow_100.boxShadow};
    background-color: ${ColorTheme.White.color};
    @media (min-width: 768px) {
        width: 360px;
    }
`;

export const ViewListingReviewsReviewTextAvatar = styled.p`
    height: 48px;
    width: 48px;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    color: #222;
    border: solid 1.3px #000;
    font-weight: bold;
    position: relative;
`;

export const ViewListingReviewsReviewImage = styled.img`
    height: 48px;
    width: 48px;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    object-fit: cover;
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
`;

export const ViewListingReviewsReviewName = styled.p`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};

    margin: 0;
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    margin-bottom: 2px;
`;

export const ViewListingReviewsReviewDate = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    color: ${ColorTheme.Grey.color};
    margin: 0;
    font-family: ${TextTheme.sans_300.fontFamily};
`;

export const ViewListingReviewsReviewText = styled.p`
    max-width: 100%;
    font-size: ${TallTextTheme.sans_text_300.fontSize};
    line-height: ${TallTextTheme.sans_text_300.lineHeight};
    font-family: ${TallTextTheme.sans_text_300.fontFamily};
    margin-top: 16px;
    word-wrap: break-word;
`;

export const ReadMoreButton = styled.button`
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};

    background: none;
    border: none;
    cursor: pointer;
    text-decoration: underline;
`;

export const ViewListingHeaderProfileImageWrapper = styled.div`
    display: flex-start;
    justify-content: center;
    height: 64px;
    width: 64px;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    position: relative;
`;

export const ViewListingHeaderProfileImageVerified = styled.img`
    height: 20px;
    width: 20px;
    background: none;
    object-fit: cover;
    position: absolute;
    bottom: 0;
    right: 0;
`;

export const HeartIcon = styled.svg`
    height: 18px;
    width: 18px;
    transition: 125ms;

    &:hover {
        transform: scale(1.1);
    }

    path {
        stroke-width: 1.8;
        box-shadow: ${ShadowTheme.shadow_100.boxShadow};
    }
`;

export const ViewListingReviewPop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: ${ColorTheme.White.color};
    z-index: 200;
    overflow: scroll;
    overflow-x: hidden;
`;

export const ViewListingReviewPopCloseBtnWrapper = styled.button`
    width: 16px;
    height: 16px;
    border: none;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    background: none;
    cursor: pointer;
    margin: ${SpacingTheme.spacing_400.margin};

    &:hover {
        background-color: ${ColorTheme.Grey5.color};
    }

    @media (min-width: 768px) {
        margin: ${SpacingTheme.spacing_500.margin};
    }
`;

export const ViewListingReviewPopCloseBtnIcon = styled.img`
    height: 100%;
    width: 100%;
    cursor: pointer;
`;

export const ViewListingReviewPopWrapper = styled.div`
    margin: 0 24px;
    margin-bottom: 32px;
    padding-top: 32px;

    @media (min-width: 768px) {
        max-width: 1184px;
        margin: 0 auto;
        margin-bottom: 48px;
        padding: 0 32px;
        padding-top: 48px;
    }
`;

export const ViewListingReviewPopTitle = styled.p`
    font-size: ${TextTheme.sans_900_semi.fontSize};
    font-style: normal;
    font-family: ${TextTheme.sans_900_semi.fontFamily};
    line-height: ${TextTheme.sans_900_semi.lineHeight};

    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_1000_semi.fontSize};
        font-style: normal;
        font-family: ${TextTheme.sans_1000_semi.fontFamily};
        line-height: ${TextTheme.sans_1000_semi.lineHeight};
    }
`;



export const ViewListingReviewPopRateWrapper = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: calc(50% - 12px) calc(50% - 12px);
    gap: ${SpacingTheme.spacing_400.gap};
    margin-top: 24px;

    @media (min-width: 768px) {
        grid-template-columns: calc((100% - 96px) / 3) calc((100% - 96px) / 3) calc((100% - 96px) / 3);
        gap: ${SpacingTheme.spacing_400.gap} 48px;
        margin-top: 48px;
    }
`;

export const ViewListingReviewPopSwiperWrapper = styled.div`
    width: 100%;
    height: fit-content;
`;

export const ViewListingReviewPopItemWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${SpacingTheme.spacing_500.gap};

    @media (min-width: 768px) {
        gap: ${SpacingTheme.spacing_600.gap};
    }
`;

export const ViewListingReviewPopReviewWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    height: fit-content;
`;

// view listing similar stays styles
export const ViewListingSimilarStaysWrapper = styled.div`
    width: 100%;
    padding: ${SpacingTheme.spacing_500.padding} 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${SpacingTheme.spacing_500.gap};
    border-top: 1px solid ${ColorTheme.Grey2.color};

    @media (min-width: 768px) {
        padding: ${SpacingTheme.spacing_600.padding} 0;
        gap: ${SpacingTheme.spacing_600.gap};
    }
`;

export const ViewListingSimilarStaysTitle = styled.h1`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    line-height: ${TextTheme.sans_700_semi.lineHeight};

    width: 90%;
    text-align: center;

    @media (min-width: 768px) {
        width: unset;
        text-align: unset;
        font-size: ${TextTheme.sans_900_semi.fontSize};
        font-family: ${TextTheme.sans_900_semi.fontFamily};
        line-height: ${TextTheme.sans_900_semi.lineHeight};
    }
`;

export const ViewListingSimilarStaysCarouselWrapper = styled(Swiper)`
    width: 100%;

    @media (min-width: 768px) {
        overflow: visible;
    }
    ::-webkit-scrollbar {
        display: none;
    }

    /* .swiper-wrapper {
        transition-timing-function: linear !important;
    } */
    .swiper-button-next,
    .swiper-button-prev {
        height: 36px;
        width: 36px;
        top: 108px;
        margin: 0;
        border-radius: 50%;
        background: ${ColorTheme.White.color};
        color: ${ColorTheme.Black.color};
        box-shadow: ${ShadowTheme.shadow_100.boxShadow};
    }

    .swiper-button-next {
        right: calc(0px - ((100vw - 1120px) / 2 - 24px));
    }
    .swiper-button-prev {
        left: calc(0px - ((100vw - 1120px) / 2 - 24px));
    }

    .swiper-button-next:after,
    .swiper-button-prev:after {
        font-size: 14px !important;
    }
    .swiper-button-next:hover,
    .swiper-button-prev:hover {
        background: ${ColorTheme.Grey5.color};
    }
`;

export const ViewListingSimilarStaysCarouselItem = styled(SwiperSlide)`
    width: 262px;
`;

export const RatingNumberSpan = styled.span`
    width: 32px;
    height: 20px;
    margin: 8px 2px 24px 0;
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    color: ${ColorTheme.Black.color};
`;

// Host Info Section Styling
export const ViewListingHostInfoImageWrapper = styled.div`
    position: relative;
    height: 40px;
    width: 40px;
`;

export const ViewListingHostInfoImage = styled.img`
    height: 40px;
    width: 40px;
    object-fit: cover;
    border-radius: 50%;
`;

export const ViewListingHostInfoTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ViewListingHostInfoTitle = styled.h3`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300_semi.fontFamily};
    margin: 0 0 4px 0;
    padding: 0;

    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_400.fontSize};
        line-height: ${TextTheme.sans_400.lineHeight};
        font-family: ${TextTheme.sans_400_semi.fontFamily};
    }
`;

export const ViewListingHostInfoTextAvatar = styled.div`
    height: 40px;
    width: 40px;
    border-radius: 50%;
    border: 1px solid ${ColorTheme.Grey2.color};
    background-color: ${ColorTheme.White.color};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${TextTheme.sans_400.fontSize};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    line-height: ${TextTheme.sans_400.lineHeight};
    color: ${ColorTheme.Black.color};
    position: relative;
`;

export const ViewListingHostInfoVerified = styled.img`
    height: 16px;
    width: 16px;
    position: absolute;
    bottom: -2px;
    right: -2px;
    z-index: 1;
`;

export const ViewListingConciergeWrapper = styled.div<{ hidden?: boolean }>`
    display: ${(props) => (props.hidden ? 'none' : 'flex')};
    align-items: center;
    gap: 12px;
    padding: 16px;
    /* border: 1px solid ${ColorTheme.Grey2.color}; */
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
    margin-bottom: 24px;
    background: rgba(245, 244, 238);
`;

export const ViewListingConciergeContent = styled.div`
    flex: 1;
`;

export const ViewListingConciergeTitle = styled.p`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    margin: 0;
    margin-bottom: 8px;
`;

export const ViewListingConciergeText = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};
    color: ${ColorTheme.Grey.color};
    margin: 0;
`;

export const ViewListingConciergeInputWrapper = styled.div`
    position: relative;
    width: 100%;
    margin-top: 16px;
`;

export const ViewListingConciergeInput = styled.input`
    width: 100%;
    padding: 10px 48px 10px 16px;
    border-radius: 999px;
    border: 1px solid ${ColorTheme.Grey2.color};
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    outline: none;
    background: #fff;
    box-sizing: border-box;
    height: 48px;

    &::placeholder {
        color: ${ColorTheme.Grey.color};
        opacity: 1;
    }
`;

export const ViewListingConciergeSendButton = styled.button`
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    height: 32px;
    min-width: 56px;
    padding: 0 16px;
    border: none;
    border-radius: 999px;
    background: ${ColorTheme.Black.color};
    color: ${ColorTheme.White.color};
    font-size: ${TextTheme.sans_300_semi.fontSize};
    font-family: ${TextTheme.sans_300_semi.fontFamily};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s;
    &:hover {
        background: ${ColorTheme.Grey.color};
        color: ${ColorTheme.White.color};
    }
`;

export const ViewListingConciergeExamples = styled.div`
    margin: 16px 0 0 0;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

export const ViewListingConciergeExampleButton = styled.button`
    border: 1px solid ${ColorTheme.Grey2.color};
    background: ${ColorTheme.Grey5.color};
    color: ${ColorTheme.Grey.color};
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    border-radius: 999px;
    padding: 0 16px;
    height: 34px;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
    opacity: 0.95;
    display: flex;
    align-items: center;
    &:hover {
        background: ${ColorTheme.Grey3.color};
        color: ${ColorTheme.Black.color};
        border-color: ${ColorTheme.Grey3.color};
    }
`;

export const ViewListingReviewNewText = styled.span`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    color: ${ColorTheme.Black.color};
    letter-spacing: 0.01em;
`;

// Extras Section Styling
export const ViewListingExtrasWrapper = styled.div`
    width: 100%;
    padding: ${SpacingTheme.spacing_500.padding} 0;
    border-top: 1px solid ${ColorTheme.Grey2.color};

    @media (min-width: 768px) {
        padding: ${SpacingTheme.spacing_600.padding} 0;
    }
`;

export const ViewListingExtrasTitle = styled.h3`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    margin: 0 0 24px 0;
    padding: 0;
`;

export const ViewListingExtrasContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px 16px;

    @media (min-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 48px 24px;
    }

    @media (min-width: 1024px) {
        grid-template-columns: repeat(4, 1fr);
        gap: 48px 24px;
    }

    @media (min-width: 1280px) {
        grid-template-columns: repeat(4, 1fr);
        gap: 48px 24px;
    }
`;

export const ViewListingExtraItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    cursor: pointer;
`;

export const ViewListingExtraImageContainer = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 20/19;
    flex-shrink: 0;
`;

export const ViewListingExtraImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const ViewListingExtraAddButton = styled.button`
    position: absolute;
    bottom: 16px;
    right: 16px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(8px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 2;

    &:hover {
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.3);
        transform: scale(1.1);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    }

    &:active {
        transform: scale(0.95);
    }

    svg {
        width: 20px;
        height: 20px;
    }
`;

export const ViewListingExtraContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const ViewListingExtraTitle = styled.h4`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    margin: 0;
    padding: 0;
    margin-bottom: 4px;
`;

export const ViewListingExtraDescription = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    font-family: ${TextTheme.sans_300.fontFamily};
    color: ${ColorTheme.Grey.color};
    margin: 0;
    padding: 0;
    margin-bottom: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const ViewListingExtraPrice = styled.p`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    color: ${ColorTheme.Black.color};
    margin: 0;
    padding: 0;
    text-decoration: underline;
`;

export const ViewListingNotFoundWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 24px 24px 24px;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
`;

export const ViewListingNotFoundIcon = styled.img`
    width: 64px;
    height: 64px;
    margin-top: 32px;
    margin-bottom: 24px;
`;

export const ViewListingNotFoundTitle = styled.h2`
    font-size: ${TextTheme.sans_700_semi.fontSize};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    color: ${ColorTheme.Black.color};
    margin: 0 0 12px 0;
    text-align: center;
`;

export const ViewListingNotFoundSubtitle = styled.p`
    font-size: ${TextTheme.sans_400.fontSize};
    line-height: ${TextTheme.sans_400.lineHeight};
    font-family: ${TextTheme.sans_400.fontFamily};
    color: ${ColorTheme.Grey.color};
    margin: 0 0 12px 0;
    text-align: center;
`;

export const ViewListingHighlightTitle = styled.p`
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
`;

export const ViewListingDescriptionPopupWrapper = styled.div`
    width: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const ViewListingDescriptionPopupTitle = styled.h2`
    font-size: ${TextTheme.sans_800_semi.fontSize};
    line-height: ${TextTheme.sans_800_semi.lineHeight};
    font-family: ${TextTheme.sans_800_semi.fontFamily};
    color: ${ColorTheme.Black.color};
    margin: 0;
    padding: 48px 24px 0;
`;

export const ViewListingDescriptionPopupText = styled.p`
    font-size: ${TallTextTheme.sans_text_300.fontSize};
    line-height: ${TallTextTheme.sans_text_300.lineHeight};
    font-family: ${TallTextTheme.sans_text_300.fontFamily};
    color: ${ColorTheme.Black.color};
    margin: 0;
    padding: 0 24px;
    white-space: pre-wrap;
`;

export const ViewListingAmenitiesPopupWrapper = styled.div`
    width: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
`;

export const ViewListingAmenitiesPopupTitle = styled.h2`
    font-size: ${TextTheme.sans_800_semi.fontSize};
    line-height: ${TextTheme.sans_800_semi.lineHeight};
    font-family: ${TextTheme.sans_800_semi.fontFamily};
    color: ${ColorTheme.Black.color};
    margin: 0;
    padding: 88px 24px 0;
`;

export const ViewListingAmenitiesPopupGrid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    gap: ${SpacingTheme.spacing_300.gap} 0;
    padding: 0 24px;

    @media (min-width: 768px) {
        grid-template-columns: 50% 50%;
    }
`;

export const ViewListingAmenitiesPopupCategoryTitle = styled.h3`
    font-size: ${TextTheme.sans_500_semi.fontSize};
    line-height: ${TextTheme.sans_500_semi.lineHeight};
    font-family: ${TextTheme.sans_500_semi.fontFamily};
    color: ${ColorTheme.Black.color};
    margin: 24px 0 24px 0;
    padding: 0 24px;
`;

export const DesktopHeaderContainer = styled.div<{ isScrolled?: boolean; lightboxOpen?: boolean }>`
    position: fixed;
    top: 0px;
    // left: 24px;
    // right: 24px;
    height: 80px;
    width: 100%;
    padding: 0 24px;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;
    transform: ${props => (props.isScrolled || props.lightboxOpen) ? 'translateY(-100%)' : 'translateY(0)'};
    transition: transform 0.2s ease;
    background: #fafafa;
    
    @media (max-width: 767px) {
        display: none;
    }
`;

export const DesktopHeaderLeft = styled.div`
    display: flex;
    align-items: center;
    pointer-events: auto;
    cursor: pointer;
    
    img {
        height: 32px;
        width: auto;
    }
`;

export const DesktopHeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    pointer-events: auto;
`;

export const DesktopHeaderButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid ${ColorTheme.Grey2.color};
    cursor: pointer;
    transition: all 0.2s ease;
    backdrop-filter: blur(16px);
    box-shadow: 1px 3px 12px 0px rgba(0, 0, 0, 0.1);

    &:hover {
        background: ${ColorTheme.Grey4.color};
    }

    img {
        width: 16px;
        height: 16px;
        object-fit: contain;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;
